module.exports = __webpack_public_path__ + "img/shot_bigtx112003.efc4d1aa.png";